import { createCustomStore } from "../common/helpers/storeHelpers";
import {
    SETTING_KEYS,
    INITIAL_SETTING,
    BASIC_SETTINGS,
    TIME_FORMAT_OPTIONS,
    INITIAL_EMPTY_SETTING,
    FILTER_TYPE,
} from "./constants";
import { getSetting } from "../common/helpers/settingStorageHelpers";
import { translations } from "./actions/localizationActions";
import { getDateRange } from "./helpers/filter/dateRange";
import { stat } from "copy-webpack-plugin/dist/utils/promisify";

const INITIAL_STATE = {
    config: {
        culture: "en",
        calendarApiUrl: CALENDAR_API_URL,
        calendarApiVersion: "v1",
        oneSignalUrl: "https://cdn.onesignal.com/sdks/OneSignalSDK.js",
        oneSignalDoc:
            "https://documentation.onesignal.com/docs/troubleshooting-web-push#clearing-your-cache-and-resetting-push-permissions",
        timezoneOffset: null,
        countryCode: [],
        dashboardUrl: null,
        notificationSoundUrl:
            "https://staticcontent.fxstreet.com/babel-fxstreet/fxstreet/_css/sounds/update.mp3",
        tracking: false,
        tradeNowUrl: null,
        tradeNowRange: 0,
        tradeNowFnc: null,
        getSpeechScoreFnc: null,
        isLocked: null,
        notificationsHelper: null,
        oneSignalAppId: null,
        initOneSignal: null,
        safariWebId: null,
        timezoneHelper: null,
        settingsOpenCloseEventName: "calendar-settings-openclose",
        subscriptionChangedEventName: "subscription-changed",
        calendarUpdateClockEventName: null,
        maxMonths: 3,
        fromYear: 2007,
        hasPremium: false,
        premiumUrl: "",
        hasPosts: false,
        enableSpeechScore: false,
        postApiUrl: POST_API_URL,
        filterType: "filter",
        productFeature: "NewsFeed",
        page: 1,
        take: 4,
        customPostUrl: "",
        sendDataFnc: null,
        showTitleMob: true,
    },
    eventDates: null,
    eventDetails: {},
    eventDateDetails: {},
    eventNotifications: [],
    notificationsSupported: true,
    eventDateDetailShown: null,
    eventDateDetailMinimalShown: null,
    eventDateMenuShown: null,
    eventNotifyShown: false,
    isFetching: true,
    eventDatesFetchError: false,
    translations: null,
    showConnectionError: false,
    settings: {},
    basicSettings: {},
    defaultSettings: {},
    showAdvancedFilter: false,
    showMobileFilter: false,
    pushConnectionStartDateUtc: null,
    showModalLegend: false,
    timezones: [],
    currentTimezone: null,
    currentTime: null,
    automaticallyTimeZone: null,
    timeFormat: TIME_FORMAT_OPTIONS.TwentyFourHours,
    showSuccessMessage: false,
    relatedNews: {},
    hasDefautTimezones: false,
    showBlockedPopup: false,
};

const convertCountryCode = (input) => {
    const result = input.split(",");
    return result;
};

const convertCulture = (input) => {
    const result =
        input && Object.keys(translations).includes(input.toLowerCase())
            ? input.toLowerCase()
            : "en";
    return result;
};

const setSpeechScoreSettings = (state) => {
    const isLockedFnc = state.config?.isLocked;

    if (isLockedFnc && typeof isLockedFnc === "function") {
        state.config.enableSpeechScore = true;
    }
};

const settingsMapper = (state) => {
    const defaultSettings = {
        ...INITIAL_SETTING,
    };

    const basicSettings = {
        ...BASIC_SETTINGS,
    };

    setSettings(state, defaultSettings, true);
    setSettings(state, basicSettings, false);

    setSpeechScoreSettings(state);

    if (state.config.premiumUrl != undefined && state.config.premiumUrl != "")
        state.config.hasPremium = true;

    let resultState = {
        ...state,
        defaultSettings,
        basicSettings,
    };

    let settings = {};
    let storageSettings = getSetting(SETTING_KEYS.Settings);

    if (storageSettings) {
        switch (storageSettings.actualFilterType) {
            case FILTER_TYPE.custom:
                settings = { ...INITIAL_EMPTY_SETTING, ...storageSettings };
                settings.filter = {
                    ...INITIAL_EMPTY_SETTING.filter,
                    ...storageSettings.filter,
                };
                break;

            case FILTER_TYPE.basic:
                settings = basicSettings;
                break;

            default:
                settings = defaultSettings;
                break;
        }
    } else {
        settings = defaultSettings;
    }

    resultState = {
        ...resultState,
        settings,
    };

    return resultState;
};

const createStore = (props) => {
    const result = createCustomStore(
        props,
        INITIAL_STATE,
        {
            countryCode: convertCountryCode,
            culture: convertCulture,
        },
        settingsMapper
    );

    return result;
};

function setSettings(state, settings, isDefaultSettings) {
    if (state.config.timezoneOffset !== undefined) {
        settings.timezoneOffset = state.config.timezoneOffset;
        settings.filter.dateRange = getDateRange(
            { time: settings.filter.time },
            settings.timezoneOffset
        );
    }

    if (
        state.config.countryCode &&
        state.config.countryCode.length > 0 &&
        isDefaultSettings
    )
        settings.filter.countries = state.config.countryCode;
}

export { createStore };
